import React from "react";
import Data from "./Data";
const Social = () => {
    return (
        <div className="home__social">
            <a href="https://twitter.com/HopeMadzi" className="home__social-icon" target="blank">
                <i class="uil uil-twitter"></i>
            </a>

            <a href="https://www.linkedin.com/in/hopemadziakapita" className="home__social-icon" target="blank">
                <i class="uil uil-linkedin"></i>
            </a>

            <a href="https://github.com/hopemadziakapita" className="home__social-icon" target="blank">
                <i class="uil uil-github"></i>
            </a>
        </div>
    )
}

export default Social;